module.exports = {
  categories: Object.freeze({
    FUEL: 'Fuel',
    DETAIL: 'Detail',
    OIL: 'Oil change',
    TIRE: 'Tires',
    DMV: 'DMV',
    MAINTENANCE: 'Maintenance',
    PARTS: 'Parts',
    BODY_SHOP: 'Body Shop',
    DEALERSHIP: 'Dealership',
    TOLL: 'Toll',
  })
};
